/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styles from './ChartPeriodControl.module.css';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import classnames from 'classnames';
import { ConsumptionPeriod } from 'model';

type PeriodButtonProps = {
  id: string;
  active: boolean;
  onSelect: () => void;
}

export const PeriodButton: React.FC<PeriodButtonProps> =  (({id, active, onSelect}) => {
  const { t } = useTranslation();
  return (
    <Col
      xs="3"
      className={classnames(
        styles.buttonContainer,
        {[styles.active]: active},
      )}
    >
      <button onClick={onSelect}>{t(id)}</button>
    </Col>
  )
})

type ChartPeriodControlProps = {
  period: ConsumptionPeriod;
  onSelect: (period: ConsumptionPeriod) => void;
}

const buttons = [
  { id: 'today', type: ConsumptionPeriod.TODAY },
  { id: 'days', type: ConsumptionPeriod.THIS_WEEK },
  { id: 'weeks', type: ConsumptionPeriod.LAST_28_DAYS },
  { id: 'months', type: ConsumptionPeriod.LAST_12_MONTHS }
];

export const ChartPeriodControl: React.FC<ChartPeriodControlProps> =  React.memo(({period, onSelect}) => {
  return (    
    <Row className={styles.root}>
      { buttons.map(b => (<PeriodButton key={b.id} id={b.id} active={b.type === period} onSelect={() => onSelect(b.type)} />)) }
    </Row>
  );
});